
















































































































































































































































































































































































































import Vue from 'vue';
import { mapState } from 'vuex';
import axios from 'axios';
import Analytics from '@/mixins/analytics';
import Helpers from '@/mixins/helpers';
import Api from '@/mixins/api';
import Validation from '@/mixins/validation';
import DealerHeader from '@/components/DealerHeader.vue';
import StepNav from '@/components/dumb/StepNav.vue';
import CarDetails from '@/components/CarDetails.vue';
import CarHeadings from '@/components/CarHeadings.vue';
import ReferenceCode from '@/components/ReferenceCode.vue';
import DetailForm from '@/components/DetailForm.vue';
import CheckoutCash from '@/components/CheckoutCash.vue';
import CheckoutFinance from '@/components/CheckoutFinance.vue';
import PayForm from '@/components/dumb/PayForm.vue';
import AgentHelp from '@/components/AgentHelp.vue';
import FinanceDetails from '@/components/FinanceDetails.vue';
import TradeIn from '@/components/TradeIn.vue';
import RateDisclaimer from '@/components/RateDisclaimer.vue';
import FieldTextarea from '@/components/dumb/FieldTextarea.vue';
import ValueAdd from '@/components/ValueAdd.vue';
import { ValueAddData } from '@/types.d';
import AlertBanner from '@/components/dumb/AlertBanner.vue';
// import AlertBannerChr from '@/components/dumb/AlertBannerChr.vue';
import { ISubmitOrderOffer, IOffersItem } from '../types';

export default Vue.extend({
	name: 'CheckoutPage',
	components: {
		DealerHeader,
		StepNav,
		CarDetails,
		CarHeadings,
		ReferenceCode,
		DetailForm,
		CheckoutCash,
		CheckoutFinance,
		PayForm,
		AgentHelp,
		FinanceDetails,
		TradeIn,
		RateDisclaimer,
		FieldTextarea,
		ValueAdd,
		AlertBanner,
		// AlertBannerChr,
	},
	data(){
		return {
			hasAcknowledged: false,
			isProcessing: false,
			isDetailFormValid: false,
			showLogin: false,
			stripeTokenId: null,
			cashFinanceTab: 1,
			payFormData: {
				stripeInstance: '',
				card: '',
				name: ''
			},
			stepItems: [
				{title: 'Vehicle', text: 'Confirm your chosen vehicle'},
				{title: 'Details', text: 'Enter your information'},
				{title: 'Payment', text: 'Choose cash or finance'},
				{title: 'Summary', text: 'Confirm details and pay deposit'}
			]
		};
	},
	computed: {
		...mapState({
			app(): any { return this.$store.state.app },
			tpr(): any { return this.$store.state.tpr },
			customer(): any { return this.$store.state.customer },
			vehicle(): any { return this.$store.state.vehicle },
			dealer(): any { return this.$store.state.dealer },
			agent(): any { return this.$store.state.agent },
			finance(): any { return this.$store.state.finance },
			financeApplication(): any { return this.$store.state.financeApplication },
			tradeIn(): any { return this.$store.state.tradeIn },
			tradeApp(): any { return this.$store.state.tradeValuationApp },
			promoCode(): any { return this.$store.state.promoCode },
			disclaimers(): any { return this.$store.state.disclaimers },
			valueAdd(): any { return this.$store.state.valueAdd }
		}),
		isWaitTimeDisclaimerEnabled(): boolean {
			return false;
		},
		showAlertMessage(): boolean {
			return false;
			// return (
			// 	!this.vehicle.model.toLowerCase().includes('gr86') &&
			// 	!this.vehicle.model.toLowerCase().includes('gr yaris') &&
			// 	!this.vehicle.model.toLowerCase().includes('lc300') &&
			// 	!this.vehicle.model.toLowerCase().includes('gr corolla')
			// );
		},
		alertMessage(): string {
			return  `Due to the unprecedented global demand, we are currently experiencing extended wait times which vary across our model range. This may result in a different specification and/or different price point at <strong>time of delivery</strong>. More information is available <a href="https://www.toyota.com.au/support/delivery-wait-times-availability" target="_blank">here</a>. Please contact us for the latest update.`;
		},
		isChr(): boolean {
			return  this.vehicle.model.toUpperCase().includes('C-HR')
		},
		customerAcceptTerms: {
			get(): string {
				return this.customer.privacyAccepted;
			},
			set(v: boolean): void {
				this.$store.commit('setCustomer', {
					privacyAccepted: v
				});
			}
		},
		customerAdditionalComment: {
			get(): string {
				return this.customer.additionalComment;
			},
			set(v: string): void {
				this.$store.commit('setCustomer', {
					additionalComment: v
				});
			}
		},
		flow(): string {
			return this.$store.getters.flow;
		},
		showSummaryTradeIn(): boolean {
			return (this.promoCode.Applied && this.promoCode.PromoType != 2) || this.tradeIn.hasTradeIn || !!this.tradeApp.car.valuationData;
		},
		isBusinessFinanceAvailable(): boolean {
			return this.$store.getters.isBusinessFinanceAvailable;
		},
		isFinanceStepValid(): boolean {
			if (this.flow == 'indicative' || this.flow == 'business'){
				return !!this.app.financeLeadOrderNumber;
			}
			else if(this.flow == 'get-tpr'){
				return false;
			}
			return true;
		},
		amountChargedToday(): number {
			return this.$store.getters.amountChargedToday;
		},
		formattedVehicleDeposit(): string {
			return Helpers.getFormattedPrice(this.$store.getters.vehicleFinalDeposit);
		},
		isPayFormValid(): boolean {
			return !!this.payFormData.name && !!this.payFormData.card && this.customer.privacyAccepted;
		},
		vehicleImageDetailForm(): string {
			return this.vehicle.imagesHero.left.replace(/png/g,'jpg');
		},
		vehicleImageDepositForm(): string {
			return this.vehicle.imagesHero.left.replace(/png/g,'jpg');
		},
		vehicleImageEstimate(): string {
			return this.vehicle.imagesHero.back.replace(/png/g,'jpg');
		},
		isCheckoutButtonsDisabled(): boolean {
			switch (this.app.step){
				case 1:
					return !this.isDetailFormValid;
				case 2:
					return this.app.paymentMethod == 'finance' && !this.isFinanceStepValid;
				case 3:
					return !this.isPayFormValid;
				default:
					return false;
			}
		}
	},
	methods: {
		handlePayFormBlur(fieldName: string): void {
			Analytics.sendEvent({
				"event": "formInteraction",
				"formName" : "Holding Deposit Form",
				"fieldName" : fieldName,
				"fieldStatus" : "Edited"
			});
		},
		handleEditButtonClick(): void {
			// todo ? TR 1.2 - "viewName" = "Confirm Your Chosen Vehicle",
			Analytics.sendEvent({
				"event":"buttonClick",
				"buttonName": "Edit Vehicle"
			});
			setTimeout(() => {
				location = this.app.changeCarUrl;
			}, 200);
		},
		handleSkipClick(): void {
			this.isProcessing = true;
			this.$router.push({name:'SummaryPage', query: this.$route.query});
			this.isProcessing = false;
		},
		handlePay(): void {
			if (this.payFormData.stripeInstance && this.payFormData.card && this.payFormData.name){
				this.isProcessing = true;
				this.getStripeToken();
			}
		},
		async getStripeToken(): Promise<any> {
			// Analytics.sendButtonClick(this.payButtonText);
			Helpers.clog('handlePayButtonClick');
			// 	util.sendButtonClick("pay and complete");
			const {token, error} = await (this.payFormData.stripeInstance as any).createToken(this.payFormData.card, {name: this.payFormData.name, 'address_country': 'AU'});
			if (error){
				// util.sendError('There was an error receiving the Stripe token. Please try again.');
				this.isProcessing = false;
				this.$store.commit('setError', {
					message: 'There was an error receiving the Stripe token. Please try again.'
				});
				// util.sendError(error.message);
			}
			else {
				this.stripeTokenId = token.id;
				this.postOrder();
			}
		},
		getOrderObject(): any {
			const d = this.disclaimers.filter((d: any) => d.for == 'vehicle').map((d: any) => (d.key + ' ' + d.text)).join(' ');
			const dSpecialOffer = this.disclaimers.filter((d: any) => d.for.includes('specialOffer'));
			const dSpecialOfferFinance: string = dSpecialOffer.filter((d: any) => d.for.includes('finance')).map((d: any) => (d.key + ' ' + d.text)).join(' ');
			const dSpecialOfferDriveaway: string = dSpecialOffer.filter((d: any) => d.for.includes('driveaway')).map((d: any) => (d.key + ' ' + d.text)).join(' ');
			const addedValues = this.valueAdd.data && typeof this.valueAdd.data == 'object' ? this.valueAdd.data.filter((o: ValueAddData) => o.selected) : [];

			const offers = this.vehicle.offers.map((o: IOffersItem) => {
				const obj: ISubmitOrderOffer = {
					offerid: o.offerid,
					validTo: o.validTo,
					offerType: o.offerType,
					price: o.price,
					mainHeading: o.main.heading
				}
				return obj;
			});
			const orderObject = {
				AddedValue: addedValues.map((o: ValueAddData) => o.id),
				DealerName: this.dealer.dealerName,
				DealerBranch: this.customer.preferredDealership,
				MyToyotaID: this.app.myToyotaId,
				LocationName: this.dealer.locationName,
				DealerID: this.dealer.dealerID,
				StockDealerID: this.dealer.stockDealerID,

				OrderType: this.customer.orderType,
				BusinessName: this.customer.orderType == 2 ? this.customer.companyName : '',
				BusinessAbn: this.customer.orderType == 2 ? this.customer.abn.replace(/ /g, '') : '',
				Title: this.customer.title,
				FirstName: this.customer.firstName,
				PreferredName: this.customer.preferredName,
				LastName: this.customer.lastName,
				DateOfBirth: this.customer.dob + 'T00:00:00',
				Telephone: this.customer.phone,
				Email: this.customer.email,
				Address: ((this.customer.unitNo && !this.customer.unitNo.includes('Unit')) ? 'Unit ' : '') +
				(this.customer.unitNo ? this.customer.unitNo + ' ' : '') +
				(this.customer.streetNo ? this.customer.streetNo + ' ' : '') +
				(this.customer.streetName ? this.customer.streetName + ' ' : '') +
				(this.customer.streetType ? this.customer.streetType : ''),
				UnitNumber: this.customer.unitNo,
				StreetNumber: this.customer.streetNo,
				StreetName: this.customer.streetName,
				StreetType: this.customer.streetType,
				Suburb: this.customer.suburb,
				Postcode: this.customer.postcode,
				State: this.customer.state,
				VehicleSpecificationID: this.vehicle.vehicleSpecificationID,
				Materialcode: this.vehicle.materialCode,
				VIN: this.vehicle.vin,
				Backlink: this.app.referrer,
				StripeTokenID: this.stripeTokenId,
				StripeErrorType: '',
				StripeErrorCode: '',
				DriveawayPrice: this.vehicle.price,
				Deposit: (this.app.paymentMethod === 'finance' ? this.app.financeDeposit : this.app.cashDeposit),
				AmountChargedToday: this.amountChargedToday,
				TermsAccepted: this.customer.privacyAccepted,
				PrivacyAccepted: this.customer.privacyAccepted,
				FinanceTermsAccepted: this.customer.privacyAccepted,
				FinanceType: (this.app.paymentMethod === 'finance' ? this.finance.financeType : 0),
				InternalFinanceType: (this.finance.isTpr ? 'tpr' : this.finance.internalFinanceType),
				LoanTermInYears: (this.app.paymentMethod === 'finance' ? this.app.loanTerm : 0),
				KmsPerYear: (this.app.paymentMethod === 'finance' ? this.app.kmsPerYear : 0),
				WeeklyRepayment: (this.app.paymentMethod === 'finance' ? this.finance.weeklyPayment : 0),
				ComparisonRate: (this.app.paymentMethod === 'finance' ? this.finance.comparisonRate : 0),
				GFV: (this.app.paymentMethod === 'finance' ? this.finance.gfv : 0),
				DealerAgencyFeeIncGST: (this.app.paymentMethod === 'finance' ? this.finance.DAFincGST : 0),
				LoanEstablishmentFee: (this.app.paymentMethod === 'finance' ? this.finance.establishmentFee : 0),
				PPSRFee: (this.app.paymentMethod === 'finance' ? this.finance.ppsrFee : 0),
				TotalAmountFinanced: (this.app.paymentMethod === 'finance' ? this.finance.totalAmountFinanced : 0),
				NetAmountFinanced: (this.app.paymentMethod === 'finance' ? this.finance.netAmountFinanced : 0),
				APR: (this.app.paymentMethod === 'finance' ? this.finance.apr : 0),
				MonthlyAccountAdministrationFee: (this.app.paymentMethod === 'finance' ? this.finance.monthlyAccountFee : 0),
				MonthlyRepayment: (this.app.paymentMethod === 'finance' ? this.finance.monthlyPayment : 0),
				FinanceDisclaimer: (this.app.paymentMethod === 'finance' ? this.finance.disclaimer + (dSpecialOfferFinance ? ' ' + dSpecialOfferFinance : '') : ''),
				AdditionalComment: this.customer.additionalComment || '',
				TrackedNumber: this.agent.phone,
				PromoCode: this.promoCode.Code,
				PromoGuestEmail: this.promoCode.Email,
				EnquirySentPreviously: this.app.financeLeadOrderNumber ? {
					Finance: this.app.financeLeadOrderNumber
				} : null,
				Vehicle: {
					Materialcode: this.vehicle.materialCode,
					VIN: this.vehicle.vin,
					BatchNumber: this.vehicle.batchNumber,
					InStock: false,
					DriveawayPrice: this.vehicle.price,
					Model: this.vehicle.model,
					Grade: this.vehicle.grade,
					FullDescription: this.vehicle.fullDescription,
					Transmission: this.vehicle.transmission,
					Paint: this.vehicle.paintName,
					Trim: this.vehicle.trimName,
					FactoryOptionDescription: this.vehicle.inclOption,
					Disclaimer: d + (dSpecialOfferDriveaway ? ' ' + dSpecialOfferDriveaway : '')
				},
				TradeIn: {
					Make: '',
					VehicleModel: (this.tradeIn.hasTradeIn ? this.tradeIn.vehicleModel : ''),
					Year: (this.tradeIn.hasTradeIn ? this.tradeIn.year : ''),
					EstimatedKms: (this.tradeIn.hasTradeIn ? this.tradeIn.km : ''),
					AdditionalInformation: (this.tradeIn.hasTradeIn ? this.tradeIn.comment : '')
				},
				Offers: offers
			};
			// append enquiry ID from previously submitted instant trade valuation post
			if (this.tradeApp.tradeValuationSubmitted && orderObject.EnquirySentPreviously !== null) {
				(orderObject.EnquirySentPreviously as any).Trade = this.tradeApp.tradeValuationEnquiryId;
			}
			else if (this.tradeApp.tradeValuationSubmitted && orderObject.EnquirySentPreviously === null){
				(orderObject.EnquirySentPreviously as any) = {
					Trade: this.tradeApp.tradeValuationEnquiryId
				}
			}
			return orderObject;
		},
		postOrder(): void {
			const orderObject = this.getOrderObject();
			const url = Api.returnPaymentPostURL();
			Helpers.clog(orderObject);
			axios.post(url, orderObject).then((response: any) => {
				Helpers.clog(response);
				const orderResult = this.financeApplication.preCheckoutCompleted ? response.data.OrderResult : response.data;
				if (orderResult.StripeSuccess){
					this.$store.commit('setApp', {
						orderHash: orderResult.OrderHash,
						orderGuid: orderResult.OrderGuid,
						orderNumber: orderResult.OrderNumber,
						paid: true
					});
					if (orderResult.orderHash){
						this.$store.commit('setFinanceApplication', {
							OrderFinance: {
								OrderID: parseInt(orderResult.orderNumber, 10),
								OrderHash: orderResult.orderHash,
								OrderGuid: orderResult.orderGuid
							}
						});
					}
					this.isProcessing = false;
					this.$router.push({name:'SummaryPage', query: this.$route.query});
				}
				else if (Validation.stripeErrors[orderResult.StripeError]){
					this.$store.commit('setError', {
						message: Validation.stripeErrors[orderResult.StripeError]
					});
					this.isProcessing = false;
				}
				else if (orderResult.StripeError === 'other_catastrophic' && orderResult.StripeErrorType === 'card_error') {
					this.$store.commit('setError', {
						message: orderResult.StripeErrorMessage
					});
					this.isProcessing = false;
				}
				else if (!orderResult.PriceCheckSuccess) {
					this.$store.commit('setError', {
						message: `Oops, an error occurred while processing your order. Don’t worry, it wasn’t your fault. Sometimes these things happen, please click OK to refresh your order. Sorry for any inconvenience.`,
						buttons: [{
							title: 'Ok',
							callback: () => { (window as any).reload() }
						}]
					});
					this.isProcessing = false;
				}
				else {
					this.$store.commit('setError', {
						message: `There was a problem with our system. Please try again later.`
					});
					this.isProcessing = false;
				}
			})
			.catch((error) => {
				Helpers.clog(error);
				this.isProcessing = false;
				this.$store.commit('setError', {
					message: `There was a problem with our system. Please try again later.`
				})
				this.isProcessing = false;
			});
		},
		handleStepNavClick(i: number): void {
			if (i < this.app.step){
				this.$store.commit('setApp', {
					step: i
				});
			}
		},
		handleTermsClick(e: any): void {
			e.stopPropagation();
			this.$store.commit('setOpenModal', {
				id: 'TermsModal'
			});
		},
		handleExternalPrivacyPolicyClick(): void {
			Analytics.sendEvent({
				"event":"buttonClick",
				"buttonName": "www.toyota.com.au/privacy."
			});
		},
		handlePrivacyPolicyClick(e: any): void {
			e.stopPropagation();
			this.$store.commit('setOpenModal', {
				id: 'PrivacyModal'
			});
		},
		handleLoginClick(): void {
			Analytics.sendEvent({
				"event":"buttonClick",
				"buttonName": "Login With MyToyota"
			});
			this.$store.commit('setOpenModal', {id:'LoginModal'});
		},
		handleLogoutClick(): void {
			Validation.clog('setting session to empty string');
			this.$store.commit('setApp', {session: ''});
		},
		handleContinueAsGuestClick(): void {
			Analytics.sendEvent({
				"event":"buttonClick",
				"buttonName": "Continue as Guest"
			});
			this.$store.commit('setApp', {
				step: 1
			});
		},
		handleBackClick(): void {
			Analytics.sendEvent({
				"event": "buttonClick",
				"buttonName": "Back"
            });
			this.$store.commit('setApp', {
				step: this.app.step - 1
			});
		},
		handleContinueClick(): void {
			const prefix = this.flow == 'business' ? 'Business Finance - ' : this.flow == 'business' ? 'Business Campaign Finance - ' : '';
			Analytics.sendEvent({
				"event": "buttonClick",
				"buttonName": prefix + "Continue"
			});
			this.$nextTick(() => {
				this.$store.commit('setApp', {
					step: this.app.step + 1
				});
			});
		},
		handlePayClick(): void {
			Analytics.sendEvent({
				'event':'buttonClick',
				'buttonName':'Pay Deposit.'
			});
			if (this.hasAcknowledged || !this.isWaitTimeDisclaimerEnabled){
				this.$nextTick(() => {
					this.handlePay();
				});
			}
			else {
				this.$store.commit('setOpenModal', {
					id: 'AcknowledgementModal',
					buttons: [{
						text: 'Accept',
						type: 'brand',
						requiresCheck: true,
						callback: () => {
							this.hasAcknowledged = true;
							this.$store.commit('resetOpenModal');
							this.$nextTick(() => {
								this.handlePay();
							});
						}
					}, {
						text: 'Close',
						type: 'text',
						callback: () => {
							this.$store.commit('resetOpenModal');
						}
					}]
				});
			}
		},
		handleCollapseClick(): void {
			this.$scrollTo((this as any).$refs.stepNav.$el, 500, {
				offset: -40
			});
		},
		sendVirtualPageView(): void {
			let viewSection = '';
			let viewName = '';
			const suffix = Analytics.getSuffix();
			switch (this.app.step){
				case 0:
					viewSection = 'vehicle';
					viewName = '01-Vehicle' + suffix;
					break;
				case 1:
					viewSection = 'your details';
					viewName = '02-Personal Details' + suffix;
					break;
				case 2:
					viewSection = 'payment';
					viewName = '03-Payment Options' + suffix;
					break;
				case 3:
					viewSection = 'summary';
					viewName = 'Confirm details and pay deposit' + suffix;
					break;
			}
			const o = {
				"event":"omnichannelCheckOutStep",
				"viewSection": viewSection,
				"viewName": viewName
			}
			Analytics.sendVirtualPageView(o);
		}
	},
	watch: {
		'cashFinanceTab'(v: number, o: number): void {
			Analytics.sendEvent({
				"event": "setPaymentPreference",
				"paymentPreference": v == 0 ? 'Cash' : 'Finance'
			});

			const paymentMethod = v == 0 ? 'cash' : 'finance';
			this.$store.commit('setApp', {
				paymentMethod: paymentMethod
			});
			if (paymentMethod != 'cash'){
				const dateexp = new Date();
				dateexp.setDate(dateexp.getDate() + 400);//chrome limit apparently.
				const expires = "expires="+ dateexp.toString();
				const cookieData = ";" + expires + ';path=/';
				document.cookie = "selectedFinanceType=" + paymentMethod + cookieData;
			}
		},
		'app.step'(): void {
			this.cashFinanceTab = this.app.paymentMethod == 'cash' ? 0 : 1;
			this.sendVirtualPageView();
			this.$scrollTo((this as any).$refs.stepNav.$el, 500, {
				offset: -40
			});
		}
	},
	mounted(): void {
		this.sendVirtualPageView();
		this.cashFinanceTab = this.app.paymentMethod == 'cash' ? 0 : 1;

		if ((window as any).location.hash == '#tradein' && (this as any).$refs.tradein){
			this.$scrollTo((this as any).$refs.tradein.$el, 500, {
				offset: -40
			});
		}
		else if (this.app.step){
			this.$scrollTo((this as any).$refs.stepNav.$el, 500, {
				offset: -40
			});
		}
	}
});
